import AlertaGuardado from 'components/comun/AlertaGuardado'
import { useAuth } from 'context/AuthProvider'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { apiEmpresaService } from 'services/apiEmpresaService'

const DatosEmpresa = () => {
    const { empresa } = useAuth();
    const navigate = useNavigate();
    const [nombre, setNombre] = useState("")
    const [nif, setNif] = useState("")
    const [direccion, setDireccion] = useState("")
    const [email, setEmail] = useState("")
    const [nombreFiscal, setNNombreFiscal] = useState("")
    const [notificacionesCorreo, setNotificacionesCorreo] = useState(false)
    const [diasVacaciones, setDiasVacaciones] = useState("")

    const [status, setStatus] = useState("")

    const handleSubmit = async (e) => {
        e.preventDefault();
        const json = {
            nombre: nombre,
            nombreFiscal: nombreFiscal,
            nif: nif,
            direccion: direccion,
            email: email,
            diasVacaciones: diasVacaciones,
            notificacionesCorreo: notificacionesCorreo
        }
        try{
        const response = await apiEmpresaService.putById(empresa.id, json)
        setStatus("saved");
        }catch(error){
            setStatus("error")
        }
        

        await new Promise(resolve => setTimeout(resolve, 2000));
        setStatus("");
    }

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiEmpresaService.getById(empresa.id)
            setNombre(response.nombre);
            setNNombreFiscal(response.nombreFiscal)
            setDireccion(response.direccion);
            setEmail(response.email);
            setNif(response.nif);
            setDiasVacaciones(response.diasVacaciones);
            setNotificacionesCorreo(response.notificacionesCorreo);
        }
        fetchData();
    }, [empresa])

    const anchoColumnas = 12;

    return (
        <>
            <Card className='shadow'>
                <Form onSubmit={handleSubmit}>

                    <CardHeader>
                        Datos Empresa:
                    </CardHeader>
                    <CardBody>
                        <Row >                        
                            <Col lg={6}>
                                <FormGroup>
                                    <Label htmlFor="nombreFiscal" className="form-control-label">
                                        Nombre Fiscal:
                                    </Label>
                                    <Input
                                        type="text"
                                        name="nombreFiscal"
                                        className="form-control-alternative"
                                        value={nombreFiscal}
                                        onChange={(e) => setNNombreFiscal(e.target.value)}
                                        
                                    ></Input>
                                </FormGroup>
                            </Col>
                             <Col lg={6}>
                                <FormGroup>
                                    <Label htmlFor="nombre" className="form-control-label">
                                        Nif:
                                    </Label>
                                    <Input
                                        type="text"
                                        name="nif"
                                        className="form-control-alternative"
                                        value={nif}
                                        onChange={(e) => setNif(e.target.value)}
                                        
                                    ></Input>
                                </FormGroup>
                            </Col>
                           
                            <Col lg={anchoColumnas}>
                                <FormGroup>
                                    <Label htmlFor="nombre" className="form-control-label">
                                        Dirección:
                                    </Label>
                                    <Input
                                        type="text"
                                        name="nombre"
                                        className="form-control-alternative"
                                        value={direccion}
                                        onChange={(e) => setDireccion(e.target.value)}
                                        
                                    ></Input>
                                </FormGroup>
                            </Col>

                            <Col lg={anchoColumnas}>
                                <FormGroup>
                                    <Label htmlFor="nombre" className="form-control-label">
                                        Correo electronico:
                                    </Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        className="form-control-alternative"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        
                                    ></Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup >
                                    <Label htmlFor='diasVacaciones' className='form-control-label'>Días de vacaciones anuales por defecto:</Label>
                                    <Input
                                        type='number'
                                        name='diasVacaciones' 
                                        className='form-control-alternative'
                                        min={0}
                                        max={365}
                                        value={diasVacaciones}
                                        onChange={(e) => setDiasVacaciones(e.target.value)}
                                    ></Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <FormGroup check>
                                <Input
                                    type='checkbox'
                                    name='activo'
                                    id='notificacionesCorreo'
                                    checked={notificacionesCorreo}
                                    onChange={(e) => setNotificacionesCorreo(e.target.checked)}
                                />
                                <Label for="notificacionesCorreo" className="form-control-label ml-2">Recibir notificaciones pendientes por correo</Label>  
                            </FormGroup>
                            </Col>
                        </Row>

                    </CardBody>
                    <CardFooter className='text-right'>
                        <Button color="success" type='submit'>Guardar</Button>
                        <Button color="secondary" onClick={() => navigate("/admin/index")}>Volver</Button>
                    </CardFooter>

                </Form>
               
            </Card>
            <AlertaGuardado status={status}></AlertaGuardado>
        </>
    )
}

export default DatosEmpresa

